import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../Axios';
import { toggleQAModal,toggleDocumentCategoryModal, toggleMaterialCategoryModal, toggleMaterialModal, toggleCompanyModal, toggleDepartmentModal, toggleDesignationModal } from 'reducers/UiReducer';



const getAxiosConfig = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

const getErrorMessage = (error) =>
  error.response && error.response.data.message
    ? error.response.data.message
    : error.message;

const MasterReducer = createSlice({
  name: 'master',
  initialState: {
    success: false,

//QA states

    qaLoading: false,
    qaList: [],
    qaError: null,

    // DocumentCategory states
    documentCategoryLoading: false,
    documentCategoryList: [],
    documentCategoryError: null,

    // MaterialCategory states
    materialCategoryLoading: false,
    materialCategoryList: [],
    materialCategoryError: null,
    materialCategorySuccessMessage: '',

    // Material states
    materialLoading: false,
    materialList: [],
    materialError: null,
    materialSuccessMessage: '',

    // Designation states
    designationLoading: false,
    designationList: [],
    designationError: null,
    designationSuccessMessage: '',

    // Department states
    departmentLoading: false,
    departmentList: [],
    departmentError: null,
    departmentSuccessMessage: '',

    // Country states
    countryLoading: false,
    countryList: [],
    countryError: null,

    // Company states
    companyLoading: false,
    companyList: [],
    companyError: null,
  },
  reducers: {

 // QA actions
    createQARequest(state) {
      state.qaLoading = true;
    },
    createQASuccess(state, action) {
      state.qaLoading = false;
      // state.qaList.push(action.payload);
    },
    createQAFail(state, action) {
      state.qaLoading = false;
      state.qaError = action.payload;
    },
    updateQARequest(state) {
      state.qaLoading = true;
    },
    updateQASuccess(state, action) {
      state.qaLoading = false;

    },
    updateQAFail(state, action) {
      state.qaLoading = false;
      state.qaError = action.payload;
    },
    getQAListRequest(state) {
      state.qaLoading = true;
    },
    getQAListSuccess(state, action) {
      state.qaLoading = false;
      state.qaList = action.payload;
    },
    getQAListFail(state, action) {
      state.qaLoading = false;
      state.qaError = action.payload;
    },
    deleteQARequest(state) {
      state.qaLoading = true;
    },
    deleteQASuccess(state, action) {
      state.qaLoading = false;

    },
    deleteQAFail(state, action) {
      state.qaLoading = false;
      state.qaError = action.payload;
    },














    // DocumentCategory actions
    createDocumentCategoryRequest(state) {
      state.documentCategoryLoading = true;
    },
    createDocumentCategorySuccess(state, action) {
      state.documentCategoryLoading = false;
    },
    createDocumentCategoryFail(state, action) {
      state.documentCategoryLoading = false;
      state.documentCategoryError = action.payload;
    },
    updateDocumentCategoryRequest(state) {
      state.documentCategoryLoading = true;
    },
    updateDocumentCategorySuccess(state, action) {
      state.documentCategoryLoading = false;

    },
    updateDocumentCategoryFail(state, action) {
      state.documentCategoryLoading = false;
      state.documentCategoryError = action.payload;
    },
    getDocumentCategoryListRequest(state) {
      state.documentCategoryLoading = true;
    },
    getDocumentCategoryListSuccess(state, action) {
      state.documentCategoryLoading = false;
      state.documentCategoryList = action.payload;
    },
    getDocumentCategoryListFail(state, action) {
      state.documentCategoryLoading = false;
      state.documentCategoryError = action.payload;
    },
    deleteDocumentCategoryRequest(state) {
      state.documentCategoryLoading = true;
    },
    deleteDocumentCategorySuccess(state, action) {
      state.documentCategoryLoading = false;
    },
    deleteDocumentCategoryFail(state, action) {
      state.documentCategoryLoading = false;
      state.documentCategoryError = action.payload;
    },

    // MaterialCategory actions
    createMaterialCategoryRequest(state) {
      state.materialCategoryLoading = true;
      state.materialCategoryError = null;
      state.materialCategorySuccessMessage = '';
    },
    createMaterialCategorySuccess(state, action) {
      state.materialCategoryLoading = false;
      state.materialCategorySuccessMessage = action.payload || 'Material category saved successfully';
    },
    createMaterialCategoryFail(state, action) {
      state.materialCategoryLoading = false;
      state.materialCategoryError = action.payload;
    },
    updateMaterialCategoryRequest(state) {
      state.materialCategoryLoading = true;
      state.materialCategoryError = null;
      state.materialCategorySuccessMessage = '';
    },
    updateMaterialCategorySuccess(state, action) {
      state.materialCategoryLoading = false;
      state.materialCategorySuccessMessage = action.payload || 'Material category updated successfully';
    },
    updateMaterialCategoryFail(state, action) {
      state.materialCategoryLoading = false;
      state.materialCategoryError = action.payload;
    },
    getMaterialCategoryListRequest(state) {
      state.materialCategoryLoading = true;
    },
    getMaterialCategoryListSuccess(state, action) {
      state.materialCategoryLoading = false;
      state.materialCategoryList = action.payload;
    },
    getMaterialCategoryListFail(state, action) {
      state.materialCategoryLoading = false;
      state.materialCategoryError = action.payload;
    },
    deleteMaterialCategoryRequest(state) {
      state.materialCategoryLoading = true;
    },
    deleteMaterialCategorySuccess(state) {
      state.materialCategoryLoading = false;
    },
    deleteMaterialCategoryFail(state, action) {
      state.materialCategoryLoading = false;
      state.materialCategoryError = action.payload;
    },

    // Material actions
    createMaterialRequest(state) {
      state.materialLoading = true;
      state.materialError = null;
      state.materialSuccessMessage = '';
    },
    createMaterialSuccess(state, action) {
      state.materialLoading = false;
      state.materialSuccessMessage = action.payload || 'Material saved successfully';
    },
    createMaterialFail(state, action) {
      state.materialLoading = false;
      state.materialError = action.payload;
    },
    updateMaterialRequest(state) {
      state.materialLoading = true;
      state.materialError = null;
      state.materialSuccessMessage = '';
    },
    updateMaterialSuccess(state, action) {
      state.materialLoading = false;
      state.materialSuccessMessage = action.payload || 'Material updated successfully';
    },
    updateMaterialFail(state, action) {
      state.materialLoading = false;
      state.materialError = action.payload;
    },
    getMaterialListRequest(state) {
      state.materialLoading = true;
    },
    getMaterialListSuccess(state, action) {
      state.materialLoading = false;
      state.materialList = action.payload;
    },
    getMaterialListFail(state, action) {
      state.materialLoading = false;
      state.materialError = action.payload;
    },
    deleteMaterialRequest(state) {
      state.materialLoading = true;
    },
    deleteMaterialSuccess(state) {
      state.materialLoading = false;
    },
    deleteMaterialFail(state, action) {
      state.materialLoading = false;
      state.materialError = action.payload;
    },

    // Designation actions
    createDesignationRequest(state) {
      state.designationLoading = true;
      state.designationError = null;
      state.designationSuccessMessage = '';
    },
    createDesignationSuccess(state, action) {
      state.designationLoading = false;
      state.designationSuccessMessage = action.payload || 'Designation saved successfully';
      //state.designationList.push(action.payload);
    },
    createDesignationFail(state, action) {
      state.designationLoading = false;
      state.designationError = action.payload;
    },
    updateDesignationRequest(state) {
      state.designationLoading = true;
      state.designationError = null;
      state.designationSuccessMessage = '';
    },
    updateDesignationSuccess(state, action) {
      state.designationLoading = false;
      state.designationSuccessMessage = action.payload || 'Designation updated successfully';

    },
    updateDesignationFail(state, action) {
      state.designationLoading = false;
      state.designationError = action.payload;
    },
    getDesignationListRequest(state) {
      state.designationLoading = true;
    },
    getDesignationListSuccess(state, action) {
      state.designationLoading = false;
      state.designationList = action.payload;
    },
    getDesignationListFail(state, action) {
      state.designationLoading = false;
      state.designationError = action.payload;
    },
    deleteDesignationRequest(state) {
      state.designationLoading = true;
    },
    deleteDesignationSuccess(state, action) {
      state.designationLoading = false;

    },
    deleteDesignationFail(state, action) {
      state.designationLoading = false;
      state.designationError = action.payload;
    },

    // Department actions
    createDepartmentRequest(state) {
      state.departmentLoading = true;
      state.departmentError = null;
      state.departmentSuccessMessage = '';
    },
    createDepartmentSuccess(state, action) {
      state.departmentLoading = false;
      state.departmentSuccessMessage = action.payload || 'Department saved successfully';
      // state.departmentList.push(action.payload);
    },
    createDepartmentFail(state, action) {
      state.departmentLoading = false;
      state.departmentError = action.payload;
    },
    updateDepartmentRequest(state) {
      state.departmentLoading = true;
      state.departmentError = null;
      state.departmentSuccessMessage = '';
    },
    updateDepartmentSuccess(state, action) {
      state.departmentLoading = false;
      state.departmentSuccessMessage = action.payload || 'Department updated successfully';

    },
    updateDepartmentFail(state, action) {
      state.departmentLoading = false;
      state.departmentError = action.payload;
    },
    getDepartmentListRequest(state) {
      state.departmentLoading = true;
    },
    getDepartmentListSuccess(state, action) {
      state.departmentLoading = false;
      state.departmentList = action.payload;
    },
    getDepartmentListFail(state, action) {
      state.departmentLoading = false;
      state.departmentError = action.payload;
    },
    deleteDepartmentRequest(state) {
      state.departmentLoading = true;
    },
    deleteDepartmentSuccess(state, action) {
      state.departmentLoading = false;

    },
    deleteDepartmentFail(state, action) {
      state.departmentLoading = false;
      state.departmentError = action.payload;
    },
    // Company actions
    createCompanyRequest(state) {
      state.companyLoading = true;
    },
    createCompanySuccess(state, action) {
      state.companyLoading = false;
    },
    createCompanyFail(state, action) {
      state.companyLoading = false;
      state.companyError = action.payload;
    },
    updateCompanyRequest(state) {
      state.companyLoading = true;
    },
    updateCompanySuccess(state, action) {
      state.companyLoading = false;

    },
    updateCompanyFail(state, action) {
      state.companyLoading = false;
      state.companyError = action.payload;
    },
    getCompanyListRequest(state) {
      state.companyLoading = true;
    },
    getCompanyListSuccess(state, action) {
      state.companyLoading = false;
      state.companyList = action.payload;
    },
    getCompanyListFail(state, action) {
      state.companyLoading = false;
      state.companyError = action.payload;
    },
    deleteCompanyRequest(state) {
      state.companyLoading = true;
    },
    deleteCompanySuccess(state, action) {
      state.companyLoading = false;
    },
    deleteCompanyFail(state, action) {
      state.companyLoading = false;
      state.companyError = action.payload;
    },

    // Country actions
    getCountryListRequest(state) {
      state.countryLoading = true;
    }
    ,
    getCountryListSuccess(state, action) {
      state.countryLoading = false;
      state.countryList = action.payload;
    }
    ,
    getCountryListFail(state, action) {
      state.countryLoading = false;
      state.countryError = action.payload;
    }

  },
});

export const {

// Department actions
  createQARequest,
  createQASuccess,
  createQAFail,
  updateQARequest,
  updateQASuccess,
  updateQAFail,
  getQAListRequest,
  getQAListSuccess,
  getQAListFail,

  deleteQARequest,
  deleteQASuccess,
  deleteQAFail,



  // DocumentCategory actions
  getDocumentCategoryListRequest,
  getDocumentCategoryListSuccess,
  getDocumentCategoryListFail,

  createDocumentCategoryRequest,
  createDocumentCategorySuccess,
  createDocumentCategoryFail,

  updateDocumentCategoryRequest,
  updateDocumentCategorySuccess,
  updateDocumentCategoryFail,

  deleteDocumentCategoryRequest,
  deleteDocumentCategorySuccess,
  deleteDocumentCategoryFail,

  // MaterialCategory actions
  getMaterialCategoryListRequest,
  getMaterialCategoryListSuccess,
  getMaterialCategoryListFail,
  createMaterialCategoryRequest,
  createMaterialCategorySuccess,
  createMaterialCategoryFail,
  updateMaterialCategoryRequest,
  updateMaterialCategorySuccess,
  updateMaterialCategoryFail,
  deleteMaterialCategoryRequest,
  deleteMaterialCategorySuccess,
  deleteMaterialCategoryFail,

  // Material actions
  getMaterialListRequest,
  getMaterialListSuccess,
  getMaterialListFail,
  createMaterialRequest,
  createMaterialSuccess,
  createMaterialFail,
  updateMaterialRequest,
  updateMaterialSuccess,
  updateMaterialFail,
  deleteMaterialRequest,
  deleteMaterialSuccess,
  deleteMaterialFail,

  // Designation actions
  createDesignationRequest,
  createDesignationSuccess,
  createDesignationFail,
  updateDesignationRequest,
  updateDesignationSuccess,
  updateDesignationFail,
  getDesignationListRequest,
  getDesignationListSuccess,
  getDesignationListFail,
  deleteDesignationRequest,
  deleteDesignationSuccess,
  deleteDesignationFail,

  // Department actions
  createDepartmentRequest,
  createDepartmentSuccess,
  createDepartmentFail,
  updateDepartmentRequest,
  updateDepartmentSuccess,
  updateDepartmentFail,
  getDepartmentListRequest,
  getDepartmentListSuccess,
  getDepartmentListFail,

  deleteDepartmentRequest,
  deleteDepartmentSuccess,
  deleteDepartmentFail,

  getCountryListRequest,
  getCountryListSuccess,
  getCountryListFail,

  // Company actions
  createCompanyRequest,
  createCompanySuccess,
  createCompanyFail,

  updateCompanyRequest,
  updateCompanySuccess,
  updateCompanyFail,

  getCompanyListRequest,
  getCompanyListSuccess,
  getCompanyListFail,

  deleteCompanyRequest,
  deleteCompanySuccess,
  deleteCompanyFail,

} = MasterReducer.actions;



export const createQADispatch = (qaData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createDepartmentRequest());
    const { data } = await axiosInstance.post('/QA/CreateQA', qaData, config);

    if (data.status === 1) {
      dispatch(createQASuccess());
      dispatch(getQAListDispatch(qaData, token));
      dispatch(toggleQAModal(false));
    }
  } catch (error) {
    dispatch(
      createQAFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const updateQADispatch = (qaData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateQARequest());
    const { data } = await axiosInstance.post(`/QA/UpdateQA`, qaData, config);
    if (data.status === 1) {
      dispatch(updateQASuccess());
      dispatch(getQAListDispatch(qaData, token));
      dispatch(toggleQAModal(false));
    }

  } catch (error) {
    dispatch(
      updateQAFail(
        error.response?.data?.message || error.message
      )
    );
  }
};



export const getQAListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getQAListRequest());
    const config = {
      ...getAxiosConfig(token),
      params: {
        offset: form.offset,
        recordcount: form.recordcount,
      },
    };

    const { data } = await axiosInstance.get('/QA/GetQAList', config);

    console.log('QA List Data:', data);

    dispatch(getQAListSuccess(data));
  } catch (error) {

    dispatch(getQAListFail(getErrorMessage(error)));
  }
};


export const deleteQADispatch = (qaId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteQARequest());
    await axiosInstance.delete(`/QA/DeleteQAById/${qaId}`, config);
    dispatch(deleteQASuccess());
  } catch (error) {
    dispatch(
      deleteQAFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

















export const createDocumentCategoryDispatch = (categoryData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createDocumentCategoryRequest());
    const { data } = await axiosInstance.post('/DocumentCategory/CreateDocumentCategory', categoryData, config);

    if (data.status === 1) {
      dispatch(createDocumentCategorySuccess());
      dispatch(getDocumentCategoryListDispatch(categoryData, token));
      dispatch(toggleDocumentCategoryModal(false));
    }
  } catch (error) {
    dispatch(
      createDocumentCategoryFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const updateDocumentCategoryDispatch = (categoryData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateDocumentCategoryRequest());
    const { data } = await axiosInstance.post(`/DocumentCategory/UpdateDocumentCategory`, categoryData, config);
    if (data.status === 1) {
      dispatch(updateDocumentCategorySuccess());
      dispatch(getDocumentCategoryListDispatch(categoryData, token));
      dispatch(toggleDocumentCategoryModal(false));
    }

  } catch (error) {
    dispatch(
      updateDocumentCategoryFail(
        error.response?.data?.message || error.message
      )
    );
  }
};



export const getDocumentCategoryListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getDocumentCategoryListRequest());
    const { data } = await axiosInstance.get(
      '/DocumentCategory/GetDocumentCategoryList',
      getAxiosConfig(token)
    );

    dispatch(getDocumentCategoryListSuccess(data));
  } catch (error) {

    dispatch(getDocumentCategoryListFail(getErrorMessage(error)));
  }
};

export const deleteDocumentCategoryDispatch = (categoryId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteDocumentCategoryRequest());
    await axiosInstance.delete(`/document-category/${categoryId}`, config);
    dispatch(deleteDocumentCategorySuccess());
  } catch (error) {
    dispatch(
      deleteDocumentCategoryFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const createMaterialCategoryDispatch = (categoryData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createMaterialCategoryRequest());
    const { data } = await axiosInstance.post('/MaterialCategory/CreateMaterialCategory', categoryData, config);

    if (data.status === 1) {
      dispatch(createMaterialCategorySuccess(data.message || 'Material category created successfully'));
      dispatch(
        getMaterialCategoryListDispatch(
          {
            Offset: 0,
            RecordCount: 20,
            CategoryName: '',
          },
          token
        )
      );
      dispatch(toggleMaterialCategoryModal(false));
    } else {
      dispatch(createMaterialCategoryFail(data.message || 'Unable to create material category'));
    }
    return data;
  } catch (error) {
    dispatch(createMaterialCategoryFail(error.response?.data?.message || error.message));
    return {
      status: 0,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const updateMaterialCategoryDispatch = (categoryData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateMaterialCategoryRequest());
    const { data } = await axiosInstance.post('/MaterialCategory/UpdateMaterialCategory', categoryData, config);

    if (data.status === 1) {
      dispatch(updateMaterialCategorySuccess(data.message || 'Material category updated successfully'));
      dispatch(
        getMaterialCategoryListDispatch(
          {
            Offset: 0,
            RecordCount: 20,
            CategoryName: '',
          },
          token
        )
      );
      dispatch(toggleMaterialCategoryModal(false));
    } else {
      dispatch(updateMaterialCategoryFail(data.message || 'Unable to update material category'));
    }
    return data;
  } catch (error) {
    dispatch(updateMaterialCategoryFail(error.response?.data?.message || error.message));
    return {
      status: 0,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const getMaterialCategoryListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getMaterialCategoryListRequest());
    const categoryDto = form?.materialCategoryDto || {};
    const offset = form?.Offset ?? form?.offset ?? categoryDto.offset ?? 0;
    const recordCount =
      form?.RecordCount ?? form?.recordCount ?? categoryDto.recordCount ?? categoryDto.pageSize ?? 20;
    const categoryName =
      form?.CategoryName ?? form?.categoryName ?? categoryDto.CategoryName ?? categoryDto.categoryName ?? '';

    const { data } = await axiosInstance.get('/MaterialCategory/GetMaterialCategoryList', {
      ...getAxiosConfig(token),
      params: {
        Offset: offset,
        RecordCount: recordCount,
        CategoryName: categoryName,
      },
    });

    dispatch(getMaterialCategoryListSuccess(data));
  } catch (error) {
    dispatch(getMaterialCategoryListFail(getErrorMessage(error)));
  }
};

export const deleteMaterialCategoryDispatch = (categoryId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteMaterialCategoryRequest());
    await axiosInstance.delete(`/MaterialCategory/DeleteMaterialCategoryById/${categoryId}`, config);
    dispatch(deleteMaterialCategorySuccess());
  } catch (error) {
    dispatch(deleteMaterialCategoryFail(error.response?.data?.message || error.message));
  }
};

export const createMaterialDispatch = (materialData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createMaterialRequest());
    const { data } = await axiosInstance.post('/Material/CreateMaterial', materialData, config);

    if (data.status === 1) {
      dispatch(createMaterialSuccess(data.message || 'Material created successfully'));
      dispatch(
        getMaterialListDispatch(
          {
            MaterialName: '',
            CategoryId: '',
            Offset: 0,
            RecordCount: 20,
          },
          token
        )
      );
      dispatch(toggleMaterialModal(false));
    } else {
      dispatch(createMaterialFail(data.message || 'Unable to create material'));
    }
    return data;
  } catch (error) {
    dispatch(createMaterialFail(error.response?.data?.message || error.message));
    return {
      status: 0,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const updateMaterialDispatch = (materialData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateMaterialRequest());
    const { data } = await axiosInstance.post('/Material/UpdateMaterial', materialData, config);

    if (data.status === 1) {
      dispatch(updateMaterialSuccess(data.message || 'Material updated successfully'));
      dispatch(
        getMaterialListDispatch(
          {
            MaterialName: '',
            CategoryId: '',
            Offset: 0,
            RecordCount: 20,
          },
          token
        )
      );
      dispatch(toggleMaterialModal(false));
    } else {
      dispatch(updateMaterialFail(data.message || 'Unable to update material'));
    }
    return data;
  } catch (error) {
    dispatch(updateMaterialFail(error.response?.data?.message || error.message));
    return {
      status: 0,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const getMaterialListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getMaterialListRequest());
    const materialDto = form?.materialDto || {};
    const materialName =
      form?.MaterialName ?? form?.materialName ?? materialDto.MaterialName ?? materialDto.materialName ?? '';
    const categoryId =
      form?.CategoryId ?? form?.categoryId ?? materialDto.CategoryId ?? materialDto.categoryId ?? '';
    const offset = form?.Offset ?? form?.offset ?? materialDto.offset ?? 0;
    const recordCount =
      form?.RecordCount ?? form?.recordCount ?? materialDto.recordCount ?? materialDto.pageSize ?? 20;

    const { data } = await axiosInstance.get('/Material/GetMaterialList', {
      ...getAxiosConfig(token),
      params: {
        MaterialName: materialName,
        CategoryId: categoryId,
        Offset: offset,
        RecordCount: recordCount,
      },
    });

    dispatch(getMaterialListSuccess(data));
  } catch (error) {
    dispatch(getMaterialListFail(getErrorMessage(error)));
  }
};

export const deleteMaterialDispatch = (materialId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteMaterialRequest());
    await axiosInstance.delete(`/Material/DeleteMaterialById/${materialId}`, config);
    dispatch(deleteMaterialSuccess());
  } catch (error) {
    dispatch(deleteMaterialFail(error.response?.data?.message || error.message));
  }
};



export const createDepartmentDispatch = (departmentData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createDepartmentRequest());
    const { data } = await axiosInstance.post('/Department/CreateDepartment', departmentData, config);

    if (data.status === 1) {
      dispatch(createDepartmentSuccess(data.message || 'Department created successfully'));
      dispatch(
        getDepartmentListDispatch(
          {
            Offset: 0,
            RecordCount: 20,
            DepartmentName: '',
          },
          token
        )
      );
      dispatch(toggleDepartmentModal(false));
    } else {
      dispatch(createDepartmentFail(data.message || 'Unable to create department'));
    }
    return data;
  } catch (error) {
    dispatch(
      createDepartmentFail(
        error.response?.data?.message || error.message
      )
    );
    return {
      status: 0,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const updateDepartmentDispatch = (departmentData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateDepartmentRequest());
    const { data } = await axiosInstance.post(`/Department/UpdateDepartment`, departmentData, config);
    if (data.status === 1) {
      dispatch(updateDepartmentSuccess(data.message || 'Department updated successfully'));
      dispatch(
        getDepartmentListDispatch(
          {
            Offset: 0,
            RecordCount: 20,
            DepartmentName: '',
          },
          token
        )
      );
      dispatch(toggleDepartmentModal(false));
    } else {
      dispatch(updateDepartmentFail(data.message || 'Unable to update department'));
    }
    return data;

  } catch (error) {
    dispatch(
      updateDepartmentFail(
        error.response?.data?.message || error.message
      )
    );
    return {
      status: 0,
      message: error.response?.data?.message || error.message,
    };
  }
};



export const getDepartmentListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getDepartmentListRequest());
    const departmentDto = form?.departmentDto || {};
    const offset = form?.Offset ?? form?.offset ?? departmentDto.offset ?? 0;
    const recordCount =
      form?.RecordCount ?? form?.recordCount ?? departmentDto.recordCount ?? departmentDto.pageSize ?? 20;
    const departmentName =
      form?.DepartmentName ?? form?.departmentName ?? departmentDto.DepartmentName ?? departmentDto.departmentName ?? '';

    const { data } = await axiosInstance.get(
      '/Department/GetDepartmentList',
      {
        ...getAxiosConfig(token),
        params: {
          Offset: offset,
          RecordCount: recordCount,
          DepartmentName: departmentName,
        },
      }
    );

    dispatch(getDepartmentListSuccess(data));
  } catch (error) {

    dispatch(getDepartmentListFail(getErrorMessage(error)));
  }
};

export const getCountryListDispatch = (token) => async (dispatch) => {
  try {
    dispatch(getCountryListRequest());
    const { data } = await axiosInstance.get(
      '/Location/GetCountryList',
      getAxiosConfig(token)
    );

    dispatch(getCountryListSuccess(data));
  } catch (error) {

    dispatch(getCountryListFail(getErrorMessage(error)));
  }
};

export const deleteDepartmentDispatch = (DepartmentId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteDepartmentRequest());
    await axiosInstance.delete(`/department/DeleteDepartmentById/${DepartmentId}`, config);
    dispatch(deleteDepartmentSuccess());
  } catch (error) {
    dispatch(
      deleteDepartmentFail(
        error.response?.data?.message || error.message
      )
    );
  }
};


export const createDesignationDispatch = (designationData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createDesignationRequest());
    const { data } = await axiosInstance.post('/Designation/CreateDesignation', designationData, config);

    if (data.status === 1) {
      dispatch(createDesignationSuccess(data.message || 'Designation created successfully'));
      dispatch(
        getDesignationListDispatch(
          {
            Offset: 0,
            RecordCount: 20,
            DesignationName: '',
          },
          token
        )
      );
      dispatch(toggleDesignationModal(false));
    } else {
      dispatch(createDesignationFail(data.message || 'Unable to create designation'));
    }
    return data;
  } catch (error) {
    dispatch(
      createDesignationFail(
        error.response?.data?.message || error.message
      )
    );
    return {
      status: 0,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const updateDesignationDispatch = (designationData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateDesignationRequest());
    const { data } = await axiosInstance.post(`/Designation/UpdateDesignation`, designationData, config);
    if (data.status === 1) {
      dispatch(updateDesignationSuccess(data.message || 'Designation updated successfully'));
      dispatch(
        getDesignationListDispatch(
          {
            Offset: 0,
            RecordCount: 20,
            DesignationName: '',
          },
          token
        )
      );
      dispatch(toggleDesignationModal(false));
    } else {
      dispatch(updateDesignationFail(data.message || 'Unable to update designation'));
    }
    return data;

  } catch (error) {
    dispatch(
      updateDesignationFail(
        error.response?.data?.message || error.message
      )
    );
    return {
      status: 0,
      message: error.response?.data?.message || error.message,
    };
  }
};



export const getDesignationListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getDesignationListRequest());
    const designationDto = form?.designationDto || {};
    const offset = form?.Offset ?? form?.offset ?? designationDto.offset ?? 0;
    const recordCount =
      form?.RecordCount ?? form?.recordCount ?? designationDto.recordCount ?? designationDto.pageSize ?? 20;
    const designationName =
      form?.DesignationName ??
      form?.designationName ??
      designationDto.DesignationName ??
      designationDto.designationName ??
      '';

    const { data } = await axiosInstance.get(
      '/Designation/GetDesignationList',
      {
        ...getAxiosConfig(token),
        params: {
          Offset: offset,
          RecordCount: recordCount,
          DesignationName: designationName,
        },
      }
    );

    dispatch(getDesignationListSuccess(data));
  } catch (error) {

    dispatch(getDesignationListFail(getErrorMessage(error)));
  }
};

export const deleteDesignationDispatch = (designationId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteDesignationRequest());
    await axiosInstance.delete(`/designation/DeleteDesignationById/${designationId}`, config);
    dispatch(deleteDesignationSuccess());
  } catch (error) {
    dispatch(
      deleteDesignationFail(
        error.response?.data?.message || error.message
      )
    );
  }
};


export const createCompanyDispatch = (companyData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createCompanyRequest());
    const { data } = await axiosInstance.post('/Company/CreateCompany', companyData, config);

    if (data.status === 1) {
      dispatch(createCompanySuccess());
      dispatch(getLocationListDispatch(companyData, token));
      dispatch(toggleCompanyModal(false));
    }
  } catch (error) {
    dispatch(
      createCompanyFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const updateCompanyDispatch = (companyData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateCompanyRequest());
    const { data } = await axiosInstance.post(`/Company/UpdateCompany`, companyData, config);
    if (data.status === 1) {
      dispatch(updateCompanySuccess());
      dispatch(getLocationListDispatch(companyData, token));
      dispatch(toggleCompanyModal(false));
    }

  } catch (error) {
    dispatch(
      updateCompanyFail(
        error.response?.data?.message || error.message
      )
    );
  }
};



export const getLocationListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getCompanyListRequest());
    const { data } = await axiosInstance.get(
      '/Company/GetCompanyList',
      getAxiosConfig(token)
    );

    dispatch(getCompanyListSuccess(data));
  } catch (error) {

    dispatch(getCompanyListFail(getErrorMessage(error)));
  }
};

export const deleteCompanyDispatch = (companyId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteCompanyRequest());
    await axiosInstance.delete(`/designation/DeleteCompanyById/${companyId}`, config);
    dispatch(deleteCompanySuccess());
  } catch (error) {
    dispatch(
      deleteCompanyFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export default MasterReducer;
